import { WarningNotSavedModal } from 'components/modals'
import { ChangesContext } from 'contexts/ChangesContext'
import React, { useContext, useRef } from 'react'
import { NavLink as NavLinkReactRouter, useNavigate } from 'react-router-dom'

/**
 * Custom NavLink
 */
export default function NavLink({ to, children, ignoreSelected = false, exact = false }) {

  const { hasChanges, updateChanges } = useContext(ChangesContext) || { hasChanges: false }
  const navigate = useNavigate()

  const modalRef = useRef()

  const handleClick = (e) => {
    e.preventDefault()
    hasChanges ? modalRef.current.modal.open() : navigate(to)
  }

  return (
    <React.Fragment>
      <NavLinkReactRouter
        onClick   = {handleClick}
        className = {({ isActive }) => {
          if(ignoreSelected) 
            return 'menu-link'

          if(!exact)
            return isActive ? 'active menu-link' : 'menu-link'

          const urlSections = window.location.pathname.split("/")
          const toSections = to.split("/")
          const isActiveExact = (urlSections[urlSections.length - 1] == toSections[toSections.length - 1])
          return isActiveExact ? 'active menu-link' : 'menu-link'
        }}
        to={to}>
        
        {children}
      </NavLinkReactRouter>

      <WarningNotSavedModal 
        ref        = {modalRef} 
        onGoBack   = {() => {modalRef.current.modal.close()}}
        onContinue = {() => {
          modalRef.current.modal.close()
          updateChanges(false)
          navigate(to)
        }}/>
    </React.Fragment>
  )
}